module.exports = "<app-nav-header></app-nav-header>\n<router-outlet></router-outlet>\n"